import { GridModel, GridPostParams } from "common/models/utility-models/list-utility.model";
import { NotificationModel } from "./notification-data.model";

export class NotificationGridModel extends NotificationModel { }
 
export class NotificationListingModel extends GridModel<NotificationGridModel> { }
 
export class NotificationGridParams extends GridPostParams {
    pageNumber: 1;
    pageSize: 10;
    searchText: '';
    direction: '';
    column: ''
}